import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [],
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SplashScreenComponent implements OnInit {
  content = content.Data.v4_rcc_root.content.splashScreen;

  constructor(private readonly contentService: ContentService) {}

  ngOnInit(): void {
    this.contentService.getContent().subscribe((data) => {
      this.content = data.Data.v4_rcc_root.content.splashScreen;
    });
  }
}
